/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Styled } from './index.styles';
import { SaveHotelProps } from '../../organisms/OSearchResults/index.types';
import { useSavedProperties } from '../../hooks/useSavedProperties';
import { AI_SEARCH_TRACK_LABELS } from '../../constants/aiSearchTrackLabels';
import { useSearchResultsRenderedDataStore } from '../../modules/store/searchResultsRenderedDataStore';
import { AI_SEARCH_CLICK_TRACK } from '../../utils/acdlUtils';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    // extends React's HTMLAttributes
    custom_click_track_value?: string;
  }
}

export interface SaveHotelButtonProps extends SaveHotelProps {
  /** Custom click tracking value to override the default */
  clickTrackValue?: string;
  /** Full-story label (`data-track-label`) */
  trackLabel?: string;
  /** Pill with visible text (integrated imagery); icon-only uses "Favorites" + aria-pressed */
  showVisibleLabel?: boolean;
}

export const SaveHotelButton: React.FC<SaveHotelButtonProps> = ({
  propertyID,
  clickTrackValue = AI_SEARCH_CLICK_TRACK.FAVORITE_HOTEL,
  trackLabel = AI_SEARCH_TRACK_LABELS.CHAT_COMPONENT_FAVORITES,
  showVisibleLabel = false,
}) => {
  const jsonContent = useSearchResultsRenderedDataStore(state => state.jsonContent);
  const requestId = (jsonContent as any)?.envVarsObject?.['REQUEST_ID'] || '';

  const { isPropertySaved, toggleSaveProperty } = useSavedProperties({
    pageVal: 'chat',
    requestId,
  });

  const isSavedProperty = propertyID ? isPropertySaved(propertyID) : false;

  const accessibleLabel = showVisibleLabel ? (isSavedProperty ? 'Saved' : 'Favorite') : 'Favorites';
  const visibleLabel = showVisibleLabel ? (isSavedProperty ? 'Saved' : 'Favorite') : null;

  const saveHotelClick = (): void => {
    if (!propertyID) {
      return;
    }
    toggleSaveProperty(propertyID);
  };

  return (
    <Styled>
      <button
        type="button"
        className="inverse icon-container custom_click_track"
        onClick={saveHotelClick}
        {...{ custom_click_track_value: clickTrackValue }}
        data-track-label={trackLabel}
        aria-label={accessibleLabel}
        aria-pressed={isSavedProperty}
      >
        <span
          aria-hidden="true"
          className={`icon-heart-outline icon-inverse ` + (isSavedProperty ? `hide-icon` : ``)}
        />
        <span aria-hidden="true" className={`icon-heart-fill icon-inverse ` + (isSavedProperty ? `` : `hide-icon`)} />
        {visibleLabel && (
          <span aria-hidden="true" className="save-hotel-visible-label">
            {visibleLabel}
          </span>
        )}
      </button>
    </Styled>
  );
};
